<h2 mat-dialog-title>Notice</h2>

<div mat-dialog-content>
    <p>GST cannot be charged by a Registered Social Worker (RSW) or Psychologist (RPsych)</p>
</div>

<div mat-dialog-actions>
    <button class="btn btn-primary" (click)="close()">Close</button>
</div>